'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCurrentStep = updateCurrentStep;

var _CurrentStepActionTypes = require('../actionTypes/CurrentStepActionTypes');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateCurrentStep(value) {
  return function (dispatch) {
    dispatch((0, _actionWithPayload2.default)(_CurrentStepActionTypes.UPDATE_CURRENT_STEP, value));
  };
}